export const formatPostResponseData = responseData => {
  return {
    ...responseData,
    data: {
      ...responseData.data,
      metaData: {
        contacts: responseData.data.count || 0,
        description: `Version: ${responseData.data.version}`,
        id: responseData.data.id
      }
    }
  };
};
